<template>
  <div
    class="spinner relative inline-block origin-center animate-spin rounded-full mix-blend-darken"
    :class="sizeClasses.wrapper"
  >
    <span class="absolute block rounded-full bg-white" :class="sizeClasses.inner"></span>
  </div>
</template>

<script setup lang="ts">
import {computed} from 'vue';

type SpinnerSize = 'sm' | 'md' | 'inline';

interface SpinnerProps {
  size?: SpinnerSize;
}

const {size = 'md'} = defineProps<SpinnerProps>();

const sizeClasses = computed(() => {
  const sizes: Record<SpinnerSize, {wrapper: string; inner: string}> = {
    sm: {
      wrapper: 'size-7',
      inner: 'inset-1',
    },
    md: {
      wrapper: 'size-10',
      inner: 'inset-1.5',
    },
    inline: {
      wrapper: 'size-[1.125em]',
      inner: 'inset-[0.1875em]',
    },
  };
  return sizes[size];
});
</script>

<style scoped>
.spinner {
  background: conic-gradient(from 180deg at 50% 50%, rgba(42, 62, 142, 0) 0deg, #2da3dc 360deg);
  animation-duration: 1.25s;
}
</style>
